import React from 'react';
import QRCode from 'react-qr-code';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { Button, DefaultPopup, Label } from '@atlas/ui';

import { urlSeparator } from 'common/constants';

const StarsPayPopup = ({ data = {}, id }) => {
  const { url } = useRouteMatch();
  const backUrlArray = url.split(urlSeparator);
  const [isCopied, setIsCopied] = React.useState(false);
  backUrlArray.pop();

  const { redirectUrl, text, title } = data;

  const buttonLabel = React.useMemo(() => (isCopied ? 'copied' : 'copy_pix'), [isCopied]);

  const copy = React.useCallback(
    e => {
      e.preventDefault();
      const inp = document.createElement('textarea');
      document.body.appendChild(inp);
      inp.value = redirectUrl;
      inp.select();
      document.execCommand('copy', false);
      document.body.removeChild(inp);
      setIsCopied(true);
    },
    [setIsCopied, data],
  );

  const handleClose = React.useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <DefaultPopup
      className="stars-pay-modal"
      headerTitle="pix_header_title"
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <div className="popup__content">
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />

        <div className="stars-pay-modal__qr">
          <QRCode size={130} value={redirectUrl} />
        </div>
      </div>

      <div className="popup__footer">
        <Button
          className="primary big block"
          disabled={isCopied}
          label={buttonLabel}
          onClick={copy}
        />
      </div>
    </DefaultPopup>
  );
};

StarsPayPopup.propTypes = {
  data: PropTypes.object,
};

export default StarsPayPopup;
